import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQAccordionProps {
  items: FAQItem[];
}

export default function FAQAccordion({ items }: FAQAccordionProps) {
  return (
    <div className="space-y-3">
      {items.map((item) => (
        <FAQItemComponent key={item.question} item={item} />
      ))}
    </div>
  );
}

function FAQItemComponent({ item }: { item: FAQItem }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="rounded-xl border border-background-300/60 overflow-hidden bg-white">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer transition-colors hover:bg-background-100/70"
      >
        <span className="font-heading font-bold text-foreground-900 text-base pr-4">
          {item.question}
        </span>
        <div className="w-6 h-6 flex items-center justify-center shrink-0">
          <i
            className={`ri-${isOpen ? 'subtract' : 'add'}-line text-secondary-500 text-xl transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
          ></i>
        </div>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6 pb-4 text-foreground-600 text-sm leading-relaxed">
          {item.answer}
        </div>
      </div>
    </div>
  );
}